import Col from "react-bootstrap/Col";

const BenefitsCard = ({ benefit }) => {
  return (
    <Col md={6} lg={4} className="benefits-card-container mb-4">
      <div className="benefits-card bg-light-blue p-4 h-100">
        <div className="mb-4 text-primary">{benefit.icon()}</div>
        <h6>{benefit.title}</h6>
        <p className="mb-0">{benefit.description}</p>
      </div>
    </Col>
  );
};

export default BenefitsCard;
